class MFRVideoReviewsCarousel {
  constructor(i, e) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      item: ".video-reviews-carousel__entry",
      video: ".video-reviews-carousel__media video",
      image: ".video-reviews-carousel__media img",
      button: ".video-reviews-carousel__button",
    };

    this.init();
  }

  init() {
    this.$video = this.$element.find(this.selectors.video);
    this.$button = this.$element.find(this.selectors.button);

    this.$video.on("play", this.__handleVideoPlay.bind(this));
    this.$video.on("pause", this.__handleVideoPause.bind(this));
    this.$button.on("click", this.__handleButtonClick.bind(this));
  }

  __handleVideoPlay(e) {
    const item = $(e.currentTarget).closest(this.selectors.item);
    const image = item.find(this.selectors.image);
    const button = item.find(this.selectors.button);

    image.fadeOut();
    button.removeClass("play-button pause-button").addClass("pause-button");
  }

  __handleVideoPause(e) {
    const item = $(e.currentTarget).closest(this.selectors.item);
    const image = item.find(this.selectors.image);
    const button = item.find(this.selectors.button);

    image.fadeIn();
    button.removeClass("play-button pause-button").addClass("play-button");
  }

  __handleButtonClick(e) {
    const element = $( e.currentTarget );
    const item = element.closest(this.selectors.item);
    const video = item.find(this.selectors.video);

    if( element.hasClass( "play-button" ) ) {
        this.pauseAllVideos();
        video[0].play();
    }
    
    if( element.hasClass( "pause-button" ) ) video[0].pause();
  };

  pauseAllVideos() {
    this.$video.each((i, e) => $(e).get(0).pause());
  }
}